import { createStore } from "vuex"
import createPersistedState from "vuex-persistedstate"
import auth from "@/store/auth"
import session from "@/store/session"
import loading from "@/store/loading"

/**
 * Application-wide Vuex store.
 *
 * - Uses `vuex-persistedstate` to persist selected portions of the store
 *   across page reloads (configured by module or plugin where required).
 * - Registers modules for auth, session and loading state.
 */
const store = createStore({
	plugins: [createPersistedState()],
	state: {},
	getters: {},
	mutations: {},
	actions: {},
	modules: {
		auth,
		session,
		loading,
	},
})

export default store
